import { Component, OnInit } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ExpenseType } from '../../../interface/expense-type';
import { ExpenseService } from '../../../service/expense.service';
import { CommonModule } from '@angular/common';
import { MatCardSubtitle } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';


@Component({
  selector: 'app-operation-without-expensetype',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    TranslateModule,

    MatDialogTitle,
    MatDialogContent,
    MatCardSubtitle,
    MatFormFieldModule,
    MatSelect,
    MatOption,
    MatButton,
    MatDialogActions,

  ],
  templateUrl: './operation-without-expensetype.component.html',
  styleUrls: ['./operation-without-expensetype.component.css']
})
export class OperationWithoutExpensetypeComponent implements OnInit {

  selectedExpense: string;
  expenseTypes: ExpenseType[];

  constructor(
    private expenseTypeService: ExpenseService,
    private dialogRef: MatDialogRef<OperationWithoutExpensetypeComponent>
  ) { }

  ngOnInit() {
    this.getExpenses()
  }

  private async getExpenses() {
    const expenses = await this.expenseTypeService.getAll()
    this.expenseTypes = expenses;
  }

  public async close(save: boolean){
    if(save){
      this.dialogRef.close(this.selectedExpense)
    } else {
      this.dialogRef.close()
    }
  }
}
